import * as constants from './constants';

export const initialReportState = {
  loadingA3PaidFine: false,
  a3PaidFineList: [],
  loadingA3Availability: false,
  a3AvailabilityList: [],
  loadingClientRegistrationList: false,
  clientRegistrationList: [],
};

const reportsReducer = (state = initialReportState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_REPORT_A3PAIDFINE:
    case constants.FETCH_REPORT_A3PAIDFINE_SUCCESS:
    case constants.FETCH_REPORT_A3PAIDFINE_FAIL:
    case constants.FETCH_REPORT_A3AVAILABILITY:
    case constants.FETCH_REPORT_A3AVAILABILITY_SUCCESS:
    case constants.FETCH_REPORT_A3AVAILABILITY_FAIL:
    case constants.FETCH_REPORT_CLIENT_REGISTRATION:
    case constants.FETCH_REPORT_CLIENT_REGISTRATION_SUCCESS:
    case constants.FETCH_REPORT_CLIENT_REGISTRATION_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reportsReducer;
